import { MdOutlineFileUpload } from "react-icons/md";
import { GrDocumentText } from "react-icons/gr";
import { BiSolidTrash } from "react-icons/bi";

import "./style.scss";
import { useEffect, useState } from "react";
import ModalTutorial from "../ModalTutorial";
import { useModal } from "context/ModalContext/Modal.context";

interface Document {
  nameFile?: string;
  file: string;
  type: "video" | "file";
  embedUrl?: string;
}

interface Options {
  currentDocument?: Array<Document>;
  onFileSelect: (file: File | null) => void;
  onVideoSelect: (videoUrl: string) => void;
  onEmbedVideoSelect?: (embedUrl: string) => void;
  onProgressComplete: () => void;
  allowedTypes?: string[];
  maxFizeSize?: number;
}

const Attachment = ({
  currentDocument,
  onFileSelect,
  onVideoSelect,
  onEmbedVideoSelect,
  onProgressComplete,
  allowedTypes = ["image/png", "image/jpeg", "application/pdf"],
  maxFizeSize = 5,
}: Options) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [errorVideoMessage, setVideoErrorMessage] = useState<string>("");

  const [uploadProgress, setUploadProgress] = useState<number>(0);
  const [videoUrl, setVideoUrl] = useState("");
  const [document, setDocument] = useState<Document>();
  const { showModal } = useModal();

  useEffect(() => {
    if (!!currentDocument) {
      console.log("docs", currentDocument);
      if (!currentDocument) {
        return;
      }

      if (currentDocument.length >= 0) {
        let video = currentDocument.filter(
          (item) => !!item && item !== null && item.type === "video"
        );
        let file = currentDocument.filter(
          (item) => !!item && item !== null && item.type === "file"
        );

        if (!!video[0]) {
          setVideoUrl(video[0].file);
          onVideoSelect(video[0].file);
          onEmbedVideoSelect?.(video[0].embedUrl || video[0].file);
        }
        if (!!file[0]) {
          setDocument(file[0]);
        }
      }
    }
  }, [currentDocument, onVideoSelect, onEmbedVideoSelect]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];

    if (document) {
      setDocument(undefined);
    }

    if (!file) {
      setErrorMessage("Nenhum arquivo selecionado.");
      onFileSelect(null);
      return;
    }

    // Valida o tipo de arquivo
    if (!allowedTypes.includes(file.type)) {
      setErrorMessage("Tipo de arquivo não permitido.");
      onFileSelect(null);
      return;
    }

    // Valida o tamanho do arquivo
    if (file.size > maxFizeSize * 1024 * 1024) {
      setErrorMessage(`O arquivo excede o tamanho máximo de ${maxFizeSize}MB.`);
      onFileSelect(null);
      return;
    }
    // Limpa erros, seleciona o arquivo e o passa para o callback
    setErrorMessage("");
    setSelectedFile(file);
    onFileSelect(file);
    handleFakeUpload();
  };

  const handleFakeUpload = async () => {
    setUploadProgress(0);
    const interval = setInterval(() => {
      setUploadProgress((prevProgress) => {
        if (prevProgress >= 100) {
          clearInterval(interval);
          onProgressComplete();
          return 100;
        }
        return prevProgress + 10; // Incrementa 10% a cada passo
      });
    }, 200);
  };

  const isValidUrl = (url: string): boolean => {
    try {
      const parsed = new URL(url);
      return parsed.protocol === "http:" || parsed.protocol === "https:";
    } catch {
      return false;
    }
  };

const handleVideoUrlChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  const rawValue = e.target.value;
  const videoLink = rawValue.trim();

  setVideoUrl(rawValue);

  if (!videoLink) {
    onVideoSelect("");
    onEmbedVideoSelect?.("");
    setVideoErrorMessage("");
    return;
  }

  if (isValidUrl(videoLink)) {
    onVideoSelect(videoLink);
    onEmbedVideoSelect?.(videoLink);
    setVideoErrorMessage("");
  }
  else {
    onVideoSelect("");
    onEmbedVideoSelect?.("");
    setVideoErrorMessage("Cole um link válido (http/https)");
  }
};

  const handleRemoveFile = () => {
    setSelectedFile(null);
    onFileSelect(null);
    setUploadProgress(0);
  };

  return (
    <div className="attachment-wrapper mx-4 md:mx-0">
      <form>
        <div className="flex flex-col">
          <div className="flex flex-col items-start justify-start w-full field">
            <label
              htmlFor="url"
              className="text-base font-medium font-bb text-gray-bb-2"
            >
              Colar Link
            </label>
            <input
              placeholder="Colar link"
              className="w-full px-5 py-4 border-b-2 bg-gray-bb border-gray-bb-4"
              id="videoUrl"
              value={videoUrl}
              onChange={handleVideoUrlChange}
            />
            
              <p
                className="mt-3 rounded px-3 py-2 text-sm font-medium bg-pink-bb text-black-bb"
                onClick={() =>
                  showModal(
                    "tutorial",
                    <ModalTutorial tutorial_id="67aa66223de8c3182ea03a84" />,
                    "tutorial"
                  )
                }
              >
                Crie o link do seu vídeo seguindo esse passo a passo.{" "}
                <span className="text-blue-bb underline cursor-pointer">Clique aqui</span>
              </p>
          </div>
          {errorVideoMessage && (
            <p className="text-red-500">{errorVideoMessage}</p>
          )}

          {videoUrl && (
            <div className="mt-6">
              <a
                href={videoUrl}
                className="mt-4 px-4 py-2 text-white bg-blue-500 rounded hover:bg-blue-700"
                target="_blank" rel="noreferrer"
              >
                Ver vídeo 
              </a>
            </div>
          )}

          <div className="w-full py-4 my-4 border-b-2 border-gray-bb-5"></div>

          <div className="field m-w-80 max-w-[370px]">
            <h4 className="mb-2 text-base text-gray-bb-2">Anexar pdf</h4>
            <p className="text-xs text-red-300">{errorMessage}</p>

            {!!document && (
              <div
                className={`relative flex mb-4 border-2 border-dashed cursor-pointer border-gray-bb-4 p-2 gap-2 items-center ${
                  selectedFile ? "justify-between" : ""
                }`}
              >
                <>
                  <div className="flex flex-1 gap-1">
                    <div className="p-2 bg-[#EBF2FF] rounded-xl">
                      <GrDocumentText color="#4668FF" size={22} />
                    </div>
                    <div className="flex flex-col gap-2 wrapper-progress">
                      <div className="flex justify-between gap-2 text-blue-bb-2 font">
                        <p className="whitespace-nowrap">{document.nameFile}</p>
                      </div>
                    </div>
                  </div>
                </>
                <button
                  onClick={() => {
                    setDocument(undefined);
                    onFileSelect(null);
                  }}
                >
                  <BiSolidTrash color={"#888D95"} size={22} />
                </button>
              </div>
            )}

            <div
              className={`relative flex border-2 border-dashed cursor-pointer rounded-[4px] border-gray-bb-4 p-2 gap-2 items-center ${
                selectedFile ? "justify-between" : ""
              }`}
            >
              {selectedFile ? (
                <>
                  <div className="flex flex-1 gap-1">
                    <div className="p-2 bg-[#EBF2FF] rounded-xl">
                      <GrDocumentText color="#4668FF" size={22} />
                    </div>
                    <div className="flex flex-col gap-2 wrapper-progress">
                      <div className="flex justify-between gap-2 text-blue-bb-2 font">
                        <p className="whitespace-nowrap">{selectedFile.name}</p>
                        <p>{uploadProgress}%</p>
                      </div>
                      <div className="bar">
                        <div
                          className="h-1 rounded progress bg-blue-bb"
                          style={{ width: `${uploadProgress}%` }}
                        ></div>
                      </div>
                    </div>
                  </div>
                  <button onClick={handleRemoveFile}>
                    <BiSolidTrash color={"#888D95"} size={22} />
                  </button>
                </>
              ) : (
                <>
                  <div>
                    <input
                      type="file"
                      id="file-upload"
                      onChange={handleChange}
                      className="absolute top-0 left-0 w-full h-full opacity-0 file-input"
                      accept=".pdf"
                    />
                    <div className="p-2 bg-[#EBF2FF] rounded-xl">
                      <MdOutlineFileUpload color="#4668FF" size={22} />
                    </div>
                  </div>
                  <div>
                    <h5 className="text-base font-medium text-black-bb font-title">
                      Enviar arquivo
                    </h5>
                    <p className="text-xs text-gray-bb-2">
                      O tamanho máximo é de {maxFizeSize}MB
                    </p>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Attachment;
